import React from "react";

const PartnersTicker = () => {
  const partnerImages = [
    "/assets/partners/ESED-logo.jpg",
    "/assets/partners/logo-oup.png",
    "/assets/partners/psra_log.png",
    "/assets/partners/samsons_group_of_companies_logo.jpeg",
    "/assets/partners/308420674_179200721281853_1032441282494845476_n.jpg",
    "/assets/partners/324512570_1222866758319090_7796075679994201241_n.jpg",
    "/assets/partners/401092625_662728232721533_8201599142451261558_n.jpg",
  ];

  const images = [...partnerImages, ...partnerImages];

  return (
    <div className="w-full bg-gray-50 py-4 overflow-hidden">
      <h2 className="text-center text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
        Our Partners
      </h2>

      <div className="relative w-full overflow-hidden">
        <div
          className="flex items-center gap-12 whitespace-nowrap animate-marquee"
          style={{ minWidth: "200%" }}
        >
          {images.map((src, i) => (
            <div key={i} className="flex items-center justify-center">
              <img
                src={src}
                alt={`Partner ${i + 1}`}
                className="h-28 sm:h-32 lg:h-36 object-contain grayscale hover:grayscale-0 transition-transform duration-500 hover:scale-105"
                onError={(e) => (e.target.style.display = "none")}
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default PartnersTicker;
